export default __webpack_public_path__ + "static/media/billpay_banner.efe44b83.jpg";